<!-- Компонент заголовка секции, может принимать в slot доп.контент -->
<template>
<header class="section-header">
	<h2 v-if="title" class="section-header__title" itemprop="headline">{{title}}</h2>
	<h3 v-if="subtitle" class="section-header__subtitle">{{subtitle}}</h3>
	<slot></slot>
</header>
</template>
<script>
export default {
	props: {
		title: {
			type: String,
		},
		subtitle: {
			type: String,
		}
	},
}
</script>
<style lang="sass">
.section-header__title
  line-height: 23.39px
  font-size: 20px
  color: #00599B
  font-weight: 600
  text-transform: uppercase
  margin-bottom: 18px
  font-feature-settings: 'pnum' on, 'lnum' on
  font-family: 'Raleway'
  &-help
    font-feature-settings: 'pnum' on, 'lnum' on
    color: #00599B
    font-weight: 500
    font-size: 16px
    line-height: 19px

.section-header__subtitle
  color: #5B636B
  font-family: 'Raleway'
  font-size: 17px
  line-height: 18.7px
  font-weight: 400
  font-feature-settings: 'pnum' on, 'lnum' on
</style>